var inherit = require("../general.js").inherit;
var mixin = require("../general.js").mixin;

var Root = require("./root.js");
var GlobalUid = require("./globalUid.js");
var LocalUid = require("./localUid.js");
var JsonParser = require("./jsonParser.js");
var Hashifier = require("./hashifier.js");
var AssetData = require("../../assetData.js");

// General root for non-persisten editor model
var DescriptionRoot = function (dataloader, json, nodesToSkip) {
    Root.call(this);

    this.initGlobalUid();
    this.initLocalUid();
    this.initJsonParser();

    this.dataLoader = dataloader;

    // unpack data
    this.header = json["header"];
    var description = this.dejsonify(json["body"], nodesToSkip);
    this.attachData(description);
    this.disableAllObservers();
    if (description.prepareDescription) description.prepareDescription();

    this.onBubble("readOnly", function(){console.error("Descriptions cannot be edited");});
};
inherit(DescriptionRoot, Root);
mixin(DescriptionRoot, GlobalUid, LocalUid, JsonParser, Hashifier);

module.exports = DescriptionRoot;

DescriptionRoot.prototype.getAsset = function(sync) {
    return this.dataLoader.dataManager.getResource(this.header["assetType"], this.header["assetId"], sync);
};

DescriptionRoot.prototype.getAssetFromHeader = function() {
    if(!this.header['resource']) return null;
    
    var asset = new AssetData(this.header['resource']);
    asset.version = this.header['version'];
    return asset;
};

DescriptionRoot.prototype.getId = function(){
    return {"type": this.header["assetType"], "id": this.header["assetId"], "version": this.header["version"]};
};

function disableAllObservers_rec(node) {
    if(!node.isObservableTreeNode) return;
    node.forEachMember((val, col) => {
        disableAllObservers_rec(val);
    }, true, true);
    node.disableAllObservers();
}

DescriptionRoot.prototype.disableAllObservers = function(){
    disableAllObservers_rec(this.data);
};
